import React from "react";
import { GradientDivider, WaveDivider } from "../components/UI";
import GradientSection from "../components/GradientSection";
import PageLayout from "../components/PageLayout";
import PartnerCard from "../components/PartnerCard";
import { SITE_URL } from "../constants/site";
import { partners, volunteerIntro } from "../data/community";

export default function Community() {
    return (
        <PageLayout
            seo={{
                title: "Cycling Community in Missoula - Osprey Racing Volunteer Work",
                description:
                    "Osprey Racing Team's community impact in Missoula, Montana. Volunteering with Poverello Center to support homelessness initiatives.",
                url: `${SITE_URL}/community`,
                image: "/img/osprey-group.jpg",
                twitterDescription:
                    "Osprey Racing Team's community impact in Missoula, Montana.",
            }}
            title="Community Impact"
        >
            <div className="max-w-3xl mx-auto mb-16">
                <h2 className="text-2xl font-bold mb-6 text-sky-400">{volunteerIntro.heading}</h2>
                <p className="text-gray-300 mb-4">{volunteerIntro.text}</p>
            </div>

            <GradientDivider />
            <WaveDivider />

            <GradientSection>
                <h2 className="text-2xl font-bold mb-8 text-sky-400 text-center">Volunteer Work</h2>
                <div className="grid md:grid-cols-2 gap-8">
                    {partners.map((partner) => (
                        <PartnerCard key={partner.id} partner={partner} />
                    ))}
                </div>
            </GradientSection>

            <GradientDivider />
        </PageLayout>
    );
}
